import axios from '@/libs/axios';

class MarketingClient {
  constructor() {
    this.api = axios;
  }

  async list(params) {
    const { data } = await this.api.get('/marketing', { params });
    return data;
  }

  async getById(id) {
    const { data } = await this.api.get(`/marketing/${id}`);
    return data;
  }

  async upload(formData) {
    const { data } = await this.api.post('/marketing', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }

  async update(id, payload) {
    const { data } = await this.api.put(`/marketing/${id}`, payload);
    return data;
  }

  async delete(id) {
    const { data } = await this.api.delete(`/marketing/${id}`);
    return data;
  }

  async getStats() {
    const { data } = await this.api.get('/marketing/stats');
    return data;
  }

  getDownloadUrl(id) {
    return `${this.api.defaults.baseURL}/marketing/${id}/download`;
  }
}

export default new MarketingClient();
